export const SET_OPPORTUNITY_IS_LOADING = 'SET_OPPORTUNITY_IS_LOADING';
export const CLEAR_OPPORTUNITY_IS_LOADING = 'CLEAR_OPPORTUNITY_IS_LOADING';
export const SET_OPPORTUNITY_IS_SUCCESS = 'SET_OPPORTUNITY_IS_SUCCESS';
export const SET_HAS_INITIAL_OPPORTUNITIES = 'SET_HAS_INITIAL_OPPORTUNITIES';

export const setOpportunityIsLoading = scheduleId => ({ type: SET_OPPORTUNITY_IS_LOADING, scheduleId });
export const clearOpportunityIsLoading = scheduleId => ({ type: CLEAR_OPPORTUNITY_IS_LOADING, scheduleId });
export const setOpportunityIsSuccess = (scheduleId, updatedCapacity) => ({
  type: SET_OPPORTUNITY_IS_SUCCESS,
  scheduleId,
  updatedCapacity,
});
export const setHasInitialOpportunities = hasInitial => ({ type: SET_HAS_INITIAL_OPPORTUNITIES, hasInitial });

const initialState = {
  hasInitial: false,
  status: {
    // [scheduleId] : {
    //   isLoading: false,
    //   isSuccess: false,
    //   updatedCapacity: 0,
    // }
  },
};

export default (state = initialState, action) => {
  const { type, scheduleId, updatedCapacity, hasInitial } = action;

  switch (type) {
    case SET_HAS_INITIAL_OPPORTUNITIES:
      return {
        ...state,
        hasInitial,
      };

    case SET_OPPORTUNITY_IS_LOADING:
      return {
        ...state,
        status: {
          ...state.status,
          [scheduleId]: {
            ...(state.status[scheduleId] || {}),
            isLoading: true,
          },
        },
      };

    case CLEAR_OPPORTUNITY_IS_LOADING:
      return {
        ...state,
        status: {
          ...state.status,
          [scheduleId]: {
            ...(state.status[scheduleId] || {}),
            isLoading: false,
          },
        },
      };

    case SET_OPPORTUNITY_IS_SUCCESS:
      return {
        ...state,
        status: {
          ...state.status,
          [scheduleId]: {
            ...(state.status[scheduleId] || {}),
            isLoading: false,
            isSuccess: true,
            updatedCapacity,
          },
        },
      };

    default:
      return state;
  }
};
